import React, { useState, useContext, useEffect, useCallback } from "react";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import RadioGroup from "@mui/material/RadioGroup";
import FormControl from "@mui/material/FormControl";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import CardContent from "@mui/material/CardContent";
import Iphone from "../../assets/iphone.png";
import Drawer from "../../assets/drawer.png";
import Drawer2 from "../../assets/drawer2.png";
import TabBar from "../../assets/tabBar.png";
import TabBar2 from "../../assets/tabBar2.png";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Radio from "@mui/material/Radio";
import { makeStyles } from "@mui/styles";
import { UserContext } from "../../context/UserContext";
import axios from "axios";
import { ADMIN_URL } from "../../utils/constants";
import {
	CircularProgress,
	Divider,
	InputAdornment,
	InputLabel,
	Modal,
	TextField,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import GooglePlayImage1 from "../../assets/google-play-users1.png";
import GooglePlayImage2 from "../../assets/google-play-users2.png";
import AppStore from "../../assets/appstore-users.png";
import { useTranslation } from "react-i18next";
import useMediaQuery from "@mui/material/useMediaQuery";

const useStyles = makeStyles({
	iphone: {
		width: 260,
		padding: 20,
		paddingTop: 0,
	},
	cardInfo: {
		display: "flex",
		width: "100%",
		justifyContent: "center",
	},
	cardForm: {
		display: "flex",
	},
	cardGrid: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
	},
	cardPageInfo: {
		display: "flex",
		width: "100%",
		justifyContent: "center",
	},
	tabs: {
		"& .MuiTab-root.Mui-selected": {
			color: "#43BD98",
			fontWeight: 700,
		},

		"& .MuiTabs-flexContainer": {
			justifyContent: "center",
		},
	},
});

const stripePlans = {
	SERVICES_PRO_PLAN: ["prod_N8ENbJht8AXHvl", "prod_ODk67S2S4sRJGL"],
	ECOMMERCE_PRO_PLAN: ["prod_NvMbyb2QnBLRp4", "prod_ODjgbQugklelMP"],
	WOOCOMMERCE_PRO_PLAN: ["prod_NvMmrn8ZxdiU8G", "prod_ODkDici8t0e44u"],
};

export default function Publish({
	drawerWidth,
	setRun,
	onboardingFinished,
	setOnboardingFinished,
}) {
	const classes = useStyles();
	const [loading, setLoading] = useState(false);
	const [initialLoading, setInitialLoading] = useState(true);
	const [creator, setCreator] = useState({});
	const [settings, setSettings] = useState({});
	const [accountName, setAccountName] = useState(null);
	const [appStatus, setAppStatus] = useState(null);
	const [step, setStep] = useState(1);
	const [showBuildModal, setShowBuildModal] = useState(false);
	const [showBackModal, setShowBackModal] = useState(false);
	const [showPublishModal, setShowPublishModal] = useState(false);
	const [showMetadataModal, setShowMetadataModal] = useState(false);
	const [showPublishBackModal, setShowPublishBackModal] = useState(false);
	const { user, getUser, setUser } = useContext(UserContext);
	const navigate = useNavigate();
	const [selectedTab, setSelectedTab] = useState(0);
	const { t } = useTranslation();
	const isSmall = useMediaQuery("(max-width: 1200px)");
	const [androidId, setAndroidId] = useState(user.app.androidId ?? null);
	const [appleId, setAppleId] = useState(user.app.appleId ?? null);
	const [editing, setEditing] = useState(false);
	const [seeSteps, setSeeSteps] = useState(
		!user.app.androidId || !user.app.appleId
	);

	function a11yProps(index) {
		return {
			id: `tab-${index}`,
			"aria-controls": `tabpanel-${index}`,
		};
	}

	useEffect(() => {
		console.log("NOW ON PUBLISH");
		setRun(true);
	}, []);

	useEffect(() => {
		if (onboardingFinished) {
			setUser({ ...user, finishOnboarding: true });
			navigate("/");
		}
	}, [onboardingFinished]);

	const steps = useCallback(() => {
		const getUserModiyTimes = () => {
			return user.app.appStatuses.filter(
				(status) =>
					status.status === "published" &&
					new Date(status.createdAt) >
						new Date(new Date().getFullYear() + "-01-01")
			).length;
		};
		const getTotalModifyTimes = () => {
			return 5;
		};

		const stepsArray = [
			{
				title: <>{t("publish.activePlan")}</>,
				description: <>{t("publish.activePlanDesc")}</>,
				buttonTitle: <>{t("publish.activePlanButton")}</>,
				buttonAction: () => {
					navigate("/settings");
				},
			},
			{
				title: <>{t("publish.requiredField")}</>,
				description: "",
				buttonTitle: <>{t("publish.requiredFieldButton")}</>,
				buttonAction: () => {
					navigate("/");
				},
			},
			appStatus?.status === "rejected"
				? {
						title: <>{t("publish.rejectedApp")}</>,
						description: (
							<>
								<Box
									sx={{
										background: "#fafafe",
										padding: 4,
										whiteSpace: "pre-wrap",
										borderRadius: 2,
									}}
								>
									<b>{appStatus.message}</b>
								</Box>
								<br />
								<br />
								{t("publish.rejectedAppDesc")}
							</>
						),
						buttonTitle: <>{t("publish.rejectedAppButton")}</>,
						buttonAction: () => {
							setShowBuildModal(true);
						},
				  }
				: {
						title: <>{t("publish.designApp")}</>,
						description: <>{t("publish.designAppDesc")}</>,
						buttonTitle: <>{t("publish.designAppButton")}</>,
						disabled:
							user.app.appStatuses.filter((status) => status.status === "built")
								.length >= 5,
						disabledText: (
							<>
								{t("publish.contactUs") + " "}

								<a
									href="mailto:info@applaby.com"
									target="_blank"
									rel="noreferrer"
								>
									info@applaby.com
								</a>
								{" " + t("publish.contactUs2")}
							</>
						),
						buttonAction: () => {
							setShowBuildModal(true);
						},
				  },
			{
				title: <>{t("publish.inviteUs")}</>,
				description: (
					<Box>
						{t("publish.inviteUsDesc1")}
						<br /> {t("publish.inviteUsDesc2")}
						<br />
						<br />
						<Box
							sx={{
								borderTop: 1,
								borderBottom: 1,
								borderColor: "divider",
								marginTop: 1,
								paddingTop: 4,
								paddingBottom: 2,
							}}
						>
							{androidId && appleId && !editing ? (
								<Typography
									sx={{ gap: 2, textAlign: "center", margin: "auto" }}
									maxWidth={400}
								>
									<b>{t("publish.accountInvited")}</b>
									<br />
									<br />
									<Button
										sx={{ width: "auto", minWidth: 140 }}
										variant="contained"
										onClick={async () => {
											setEditing(true);
										}}
										size="medium"
									>
										{t("publish.edit")}
									</Button>
									<br />
									<br />
									<Button
										sx={{
											width: "auto",
											minWidth: 140,
											textTransform: "inherit",
											color: "#43BD98",
										}}
										variant="text"
										onClick={() => {
											setSeeSteps(!seeSteps);
											console.log(seeSteps);
										}}
										size="medium"
									>
										{seeSteps ? t("publish.hideSteps") : t("publish.seeSteps")}
									</Button>
								</Typography>
							) : (
								<Typography sx={{ gap: 2 }}>
									{t("publish.inviteAccount")}
									<br />
									<br />
									<FormControl
										fullWidth
										variant="standard"
										sx={{ marginTop: 2, marginBottom: 1, maxWidth: "400px" }}
									>
										<InputLabel
											shrink
											htmlFor="app-description-input"
											sx={{
												marginTop: -2,
												fontWeight: 700,
												textTransform: "uppercase",
												fontSize: 12,
											}}
										>
											{t("publish.inviteAccountPlaceholderAndroid")}
										</InputLabel>

										<TextField
											id="app-description-input"
											fullWidth
											variant="outlined"
											value={androidId}
											onChange={(e) => {
												setEditing(true);
												setAndroidId(e.target.value);
											}}
										></TextField>
									</FormControl>
									<FormControl
										fullWidth
										variant="standard"
										sx={{ marginTop: 2, marginBottom: 1, maxWidth: "400px" }}
									>
										<InputLabel
											shrink
											htmlFor="app-description-input"
											sx={{
												marginTop: -2,
												fontWeight: 700,
												textTransform: "uppercase",
												fontSize: 12,
											}}
										>
											{t("publish.inviteAccountPlaceholderiOS")}
										</InputLabel>

										<TextField
											id="app-description-input"
											fullWidth
											variant="outlined"
											value={appleId}
											onChange={(e) => {
												setEditing(true);
												setAppleId(e.target.value);
											}}
										></TextField>
									</FormControl>
									<br />
									<br />
									<Button
										sx={{ width: "auto", minWidth: 140 }}
										variant="contained"
										onClick={async () => {
											if (androidId && appleId) {
												setLoading(true);
												try {
													await axios.post(
														ADMIN_URL + "account-info",
														{
															androidId,
															appleId,
														},
														{
															headers: {
																authorization: localStorage.getItem("token"),
															},
														}
													);
													setEditing(false);
												} catch (error) {
													console.log(error);
												}
												setLoading(false);
											}
										}}
										size="medium"
										disabled={loading || !androidId || !appleId}
									>
										{loading ? (
											<CircularProgress size={12} sx={{ color: "#fff" }} />
										) : (
											t("publish.save")
										)}
									</Button>
								</Typography>
							)}
						</Box>
						{(seeSteps || editing) && (
							<>
								<br />
								<Box
									sx={{
										borderBottom: 1,
										borderColor: "divider",
										marginTop: 1,
									}}
								>
									<Tabs
										value={selectedTab}
										onChange={(e, newValue) => {
											console.log(newValue);
											setSelectedTab(newValue);
										}}
										aria-label="tabs"
										TabIndicatorProps={{
											style: {
												background: "#43bd98",
											},
										}}
										classes={{
											root: classes.tabs,
										}}
									>
										<Tab label="GOOGLE PLAY" {...a11yProps(0)} />
										<Tab label="APP STORE" {...a11yProps(1)} />
									</Tabs>
								</Box>
								<div
									role="tabpanel"
									hidden={selectedTab !== 0}
									id={`tabpanel-${0}`}
									aria-labelledby={`tab-${0}`}
								>
									{selectedTab === 0 && (
										<Box
											sx={{
												p: 3,
												display: "flex",
												flexDirection: "column",
												alignItems: "flex-start",
												gap: 2,
												maxWidth: 600,
												textAlign: "left",
											}}
										>
											<Typography>
												{t("publish.inviteUsStepAndroid1")}{" "}
												<a
													href="https://play.google.com/console/"
													style={{ fontWeight: 700 }}
													target="_blank"
													rel="noreferrer"
												>
													https://play.google.com/console/
												</a>
											</Typography>
											<Typography>
												{t("publish.inviteUsStepAndroid2")}
											</Typography>
											<Typography>
												{t("publish.inviteUsStepAndroid3")}
											</Typography>
											<Typography>
												{t("publish.inviteUsStepAndroid4_1")}{" "}
												<span style={{ color: "#43BD98", fontWeight: 700 }}>
													develop@applaby.com
												</span>{" "}
												{t("publish.inviteUsStepAndroid4_2")}
											</Typography>
											<img
												style={{ width: "100%" }}
												src={GooglePlayImage1}
												alt="google play"
											/>
											<img
												style={{ width: "100%" }}
												src={GooglePlayImage2}
												alt="google play"
											/>
										</Box>
									)}
								</div>

								<div
									role="tabpanel"
									hidden={selectedTab !== 1}
									id={`tabpanel-${1}`}
									aria-labelledby={`tab-${1}`}
								>
									{selectedTab === 1 && (
										<Box
											sx={{
												p: 3,
												display: "flex",
												flexDirection: "column",
												alignItems: "flex-start",
												gap: 2,
												maxWidth: 600,
												textAlign: "left",
											}}
										>
											<Typography>
												{t("publish.inviteUsStepIOS1")}{" "}
												<a
													href="https://appstoreconnect.apple.com/"
													style={{ fontWeight: 700 }}
													target="_blank"
													rel="noreferrer"
												>
													https://appstoreconnect.apple.com/
												</a>
											</Typography>
											<Typography>{t("publish.inviteUsStepIOS2")}</Typography>
											<Typography>{t("publish.inviteUsStepIOS3")}</Typography>
											<Typography>
												{t("publish.inviteUsStepIOS4_1")}{" "}
												<span style={{ color: "#43BD98", fontWeight: 700 }}>
													develop@applaby.com
												</span>{" "}
												{t("publish.inviteUsStepIOS4_2")}
											</Typography>
											<img
												style={{ width: "400px" }}
												src={AppStore}
												alt="app store"
											/>
										</Box>
									)}
								</div>
							</>
						)}
					</Box>
				),
			},
			{
				title: <>{t("publish.building")}</>,
				description: <>{t("publish.buildingDesc")}</>,
			},
			{
				title: <>{t("publish.readyForTesting")}</>,
				description: (
					<>
						{t("publish.readyForTestingDesc")}{" "}
						<b>
							<a
								href={
									(window.location.hostname === "127.0.0.1"
										? "http://127.0.0.1:3001"
										: "https://admin.applaby.com") +
									(localStorage.getItem("token")
										? "?session=" + localStorage.getItem("token")
										: "")
								}
							>
								{t("publish.readyForTestingDescAdmin")}
							</a>
						</b>{" "}
						{t("publish.readyForTestingDesc1")}
					</>
				),
				buttonTitle2: t("publish.readyForTestingButton"),
				buttonTitle: t("publish.backToBuilding"),
				disabled:
					user.app.appStatuses.filter((status) => status.status === "built")
						.length >= 5,
				disabledText: (
					<>
						{t("publish.contactUs") + " "}

						<a href="mailto:info@applaby.com" target="_blank" rel="noreferrer">
							info@applaby.com
						</a>
						{" " + t("publish.contactUs2")}
					</>
				),
				buttonAction2: () => {
					if (
						[
							"category",
							"countryAvailability",
							"privacyURL",
							"termsURL",
							"appPreview1",
							"appPreview2",
							"appPreview3",
							"appPreview4",
							"keywords",
							"supportURL",
							"marketingURL",
							"deleteAccountURL",
						].find((field) => !user.app[field])
					) {
						setShowMetadataModal(true);
					} else {
						setShowPublishModal(true);
					}
				},
				buttonAction: () => {
					setShowBackModal(true);
				},
			},
			{
				title: <>{t("publish.publishing")}</>,
				description: <>{t("publish.publishingDesc")}</>,
			},
			{
				title: <>{t("publish.published")}</>,
				description: (
					<Box sx={{ maxWidth: 700 }}>
						{t("publish.publishedDesc")}
						<Box
							sx={{
								display: "flex",
								gap: 2,
								marginTop: 2,
								justifyContent: "center",
							}}
						>
							<Button
								sx={{ width: "auto", minWidth: 140 }}
								variant="contained"
								onClick={() => {
									let win = window.open(user.app.androidLink);
									if (win) {
										win.focus();
									}
								}}
								size="medium"
							>
								Google Play
							</Button>
							<Button
								sx={{ width: "auto", minWidth: 140 }}
								variant="contained"
								onClick={() => {
									let win = window.open(user.app.appleLink);
									if (win) {
										win.focus();
									}
								}}
								size="medium"
							>
								App Store
							</Button>
						</Box>
						<Divider
							sx={{
								marginTop: 4,
								marginBottom: 4,
							}}
						/>
						<Box
							sx={{
								display: "flex",
								flexDirection: "column",
								justifyContent: "center",
							}}
						>
							{t("publish.currentPlanTimes")}{" "}
							<span style={{ color: "#43BD98", fontWeight: 700 }}>
								{getTotalModifyTimes()} {t("publish.timesYear")}
							</span>
							<br />
							{t("publish.alreadyUsed")}
							<span style={{ color: "#43BD98", fontWeight: 700 }}>
								{getUserModiyTimes()}/{getTotalModifyTimes()}{" "}
								{t("publish.updates")}
							</span>
							<br />
							{getUserModiyTimes() < getTotalModifyTimes() ? (
								<Button
									sx={{ width: "auto", minWidth: 140 }}
									variant="outlined"
									onClick={() => {
										setShowPublishBackModal(true);
									}}
									size="medium"
								>
									{t("publish.modifyApp")}
								</Button>
							) : (
								<Typography
									sx={{ textAlign: "center", marginTop: 2 }}
									variant="body2"
								>
									{t("publish.contactUs") + " "}

									<a
										href="mailto:info@applaby.com"
										target="_blank"
										rel="noreferrer"
									>
										info@applaby.com
									</a>
									{" " + t("publish.contactUs2")}
								</Typography>
							)}
						</Box>
					</Box>
				),
			},
		];

		return stepsArray;
	}, [
		t,
		appStatus?.status,
		appStatus?.message,
		androidId,
		appleId,
		editing,
		seeSteps,
		loading,
		selectedTab,
		classes.tabs,
		user.app,
		user.subscription.product.id,
		navigate,
	]);

	const getStep = useCallback(
		(creator) => {
			let requiredFields = [
				"appLogo",
				"appIconLogo",
				"appName",
				"appDescription",
			];

			let stripeFields = ["stripeKey", "stripePublicKey", "stripeWebhook"];
			let woocomerceFields = ["backendURL", "backendKey", "backendSecret"];

			const invitingOffset = 0;

			if (
				requiredFields.find((field) => !creator[field]) ||
				(user.app.appType !== "Services" &&
					stripeFields.find((field) => !settings[0][field])) ||
				(user.app.appType === "Woocommerce" &&
					woocomerceFields.find((field) => !creator[field])) ||
				["privacyURL", "termsURL"].find((field) => !user.app[field])
			) {
				setStep(1);
			} else if (
				appStatus.status === "pending" ||
				appStatus.status === "rejected"
			) {
				setStep(2);
			} else if (appStatus.status === "inviting") {
				setStep(3);
			} else if (appStatus.status === "building") {
				setStep(4 + invitingOffset);
			} else if (appStatus.status === "built") {
				setStep(5 + invitingOffset);
			} else if (appStatus.status === "publishing") {
				setStep(6 + invitingOffset);
			} else if (appStatus.status === "published") {
				setStep(7 + invitingOffset);
			}
		},
		[appStatus, user, settings]
	);

	useEffect(() => {
		if (creator && appStatus) {
			getStep(creator);
		}
	}, [creator, appStatus, getStep]);

	const getCreator = async () => {
		try {
			const res = await axios.get(ADMIN_URL + "creators", {
				headers: { authorization: localStorage.getItem("token") },
			});
			setCreator(res.data);
			setAccountName(res.data.accountName);
		} catch (error) {
			console.log(error);
		}
	};

	const getSettings = async () => {
		try {
			const res = await axios.get(ADMIN_URL + "platformSettings", {
				headers: { authorization: localStorage.getItem("token") },
			});
			setSettings(res.data);
		} catch (error) {
			console.log(error);
		}
	};

	const getAppStatuses = async () => {
		try {
			const res = await axios.get(ADMIN_URL + "appStatus", {
				headers: { authorization: localStorage.getItem("token") },
			});
			setAppStatus(res.data.appStatus);
		} catch (error) {
			console.log(error);
		}
	};

	const sendAppBack = async () => {
		setLoading(true);
		try {
			const res = await axios.post(
				ADMIN_URL + "sendAppBack",
				{},
				{
					headers: { authorization: localStorage.getItem("token") },
				}
			);
			setAppStatus(res.data.appStatus);
			await getData(false);
			await getUser();
			setShowBackModal(false);
		} catch (error) {
			console.log(error);
		}
		setLoading(false);
	};

	const sendAppToPublish = async () => {
		setLoading(true);
		try {
			const res = await axios.post(
				ADMIN_URL + "sendAppToPublish",
				{},
				{
					headers: { authorization: localStorage.getItem("token") },
				}
			);
			setAppStatus(res.data.appStatus);
			await getData(false);
			await getUser();
			setShowPublishModal(false);
		} catch (error) {
			console.log(error);
		}
		setLoading(false);
	};

	const sendAppToBuild = async () => {
		setLoading(true);
		try {
			const res = await axios.post(
				ADMIN_URL + "sendAppToBuild",
				{},
				{
					headers: { authorization: localStorage.getItem("token") },
				}
			);
			setAppStatus(res.data.appStatus);
			await getData(false);
			await getUser();
			setShowBuildModal(false);
		} catch (error) {
			console.log(error);
		}
		setLoading(false);
	};

	const sendAppBackPublish = async () => {
		setLoading(true);
		try {
			const res = await axios.post(
				ADMIN_URL + "sendAppBackPublish",
				{},
				{
					headers: { authorization: localStorage.getItem("token") },
				}
			);
			setAppStatus(res.data.appStatus);
			await getData(false);
			await getUser();
			setShowPublishBackModal(false);
		} catch (error) {
			console.log(error);
		}
		setLoading(false);
	};

	const getData = async (controlLoading = true) => {
		if (controlLoading) {
			setLoading(true);
		}
		try {
			await getCreator();
			await getSettings();
			await getAppStatuses();
		} catch (error) {
			console.log(error);
		}
		if (controlLoading) {
			setLoading(false);
		}
		setInitialLoading(false);
	};

	const saveGeneralData = useCallback(async () => {
		setLoading(true);
		try {
			await axios.post(
				ADMIN_URL + "creators",
				{
					accountName: accountName,
				},
				{
					headers: { authorization: localStorage.getItem("token") },
				}
			);
		} catch (error) {
			console.log(error);
		}
		setLoading(false);
	}, [accountName]);

	useEffect(() => {
		getData();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		getUser();
	}, [appStatus]);

	return (
		<>
			<Box
				component="main"
				sx={{
					flexGrow: 1,
					bgcolor: "background.default",
					p: 3,
					width: { xs: "100%", sm: "calc(100vw - " + drawerWidth + "px)" },
				}}
			>
				<Toolbar />

				<Card variant="outlined">
					<>
						<CardContent>
							<Typography
								sx={{
									fontSize: 14,
									borderBottom: "1px solid #f0f0f0",
									height: "35px",
									marginBottom: "20px",
									marginLeft: "-20px",
									marginRight: "-20px",
									padding: "0px 20px",
								}}
								color="text.secondary"
								gutterBottom
							>
								{t("publish.publishPage")}
							</Typography>
							<div className={classes.cardPageInfo}></div>
							<Stepper
								activeStep={step}
								color="#232323"
								orientation={isSmall ? "vertical" : "horizontal"}
								alternativeLabel={!isSmall}
							>
								{steps().map((step) => (
									<Step key={step.title} id="publish-message">
										<StepLabel>{step.title}</StepLabel>
									</Step>
								))}
							</Stepper>
							{initialLoading && (
								<Box justifyContent={"center"} alignItems={"center"}>
									<CircularProgress size={24} />
								</Box>
							)}
							{step > -1 && !initialLoading && (
								<Box
									sx={{
										display: "flex",
										flexDirection: "column",
										justifyContent: "center",
										alignContent: "center",
										alignItems: "center",
										margin: 4,
									}}
								>
									<Typography
										variant="h5"
										sx={{ marginBottom: 2, textAlign: "center" }}
									>
										{steps()[step].title}
									</Typography>
									<Typography
										variant="body1"
										sx={{ marginBottom: 2, textAlign: "center" }}
									>
										{steps()[step].description}
									</Typography>
									<Box sx={{ display: "flex", gap: 2 }}>
										{steps()[step].buttonTitle && (
											<Button
												sx={{ width: "auto", minWidth: 140 }}
												variant={
													steps()[step].buttonTitle2 ? "outlined" : "contained"
												}
												onClick={() => {
													steps()[step].buttonAction();
												}}
												size="medium"
												disabled={loading || steps()[step].disabled}
											>
												{loading ? (
													<CircularProgress size={12} sx={{ color: "#fff" }} />
												) : (
													steps()[step].buttonTitle
												)}
											</Button>
										)}
										{steps()[step].buttonTitle2 && (
											<Button
												sx={{ width: "auto", minWidth: 140 }}
												variant="contained"
												onClick={() => {
													steps()[step].buttonAction2();
												}}
												size="medium"
												disabled={loading || steps()[step].disabled}
											>
												{loading ? (
													<CircularProgress size={12} sx={{ color: "#fff" }} />
												) : (
													steps()[step].buttonTitle2
												)}
											</Button>
										)}
									</Box>
									{steps()[step].disabled && (
										<Typography
											sx={{
												textAlign: "center",
												marginTop: 2,
											}}
											variant="body2"
										>
											{steps()[step].disabledText}
										</Typography>
									)}
								</Box>
							)}
						</CardContent>
					</>
				</Card>
			</Box>
			<div>
				<Modal
					open={showBuildModal}
					onClose={() => {
						setShowBuildModal(false);
					}}
				>
					<Box
						sx={{
							position: "absolute",
							top: "50%",
							left: "50%",
							transform: "translate(-50%, -50%)",
							width: 800,
							bgcolor: "background.paper",
							boxShadow: 24,
							p: 4,
							maxHeight: "calc(100% - 80px)",
							overflow: "auto",
						}}
					>
						<Typography id="modal-modal-title" variant="h6" component="h2">
							{t("publish.sendBuildingModalTitle")}
						</Typography>
						<Divider
							sx={{
								marginLeft: -30,
								maxWidth: "calc(100% + 60px)",
								width: "calc(100% + 60px)",
								marginTop: 2,
							}}
						/>
						<Typography
							id="modal-modal-title"
							variant="body1"
							component="p"
							sx={{ marginTop: 4 }}
						>
							{t("publish.sendBuildingModalDesc1")}
							<br />
							<br />
							{t("publish.sendBuildingModalDesc2")}
							<br />
							<br />
							{t("publish.sendBuildingModalDesc3")}{" "}
							<b>{t("publish.sendBuildingModalDesc4")}</b>
							<br />
							<br />
							<a
								href={
									(window.location.hostname === "127.0.0.1"
										? "http://127.0.0.1:3001"
										: window.location.hostname === "localhost"
										? "http://localhost:3001"
										: "https://admin.applaby.com") +
									(localStorage.getItem("token")
										? "?session=" + localStorage.getItem("token")
										: "")
								}
								target="_blank"
								rel="noreferrer"
							>
								{t("publish.sendBuildingModalDesc5")}
							</a>
						</Typography>
						<Box
							sx={{
								display: "flex",
								justifyContent: "flex-end",
								alignItems: "center",
								marginTop: 4,
							}}
						>
							<Button
								variant="outlined"
								onClick={() => {
									setShowBuildModal(false);
								}}
								size="medium"
								disabled={loading}
							>
								{loading ? <CircularProgress size={12} /> : t("publish.cancel")}
							</Button>
							<Button
								sx={{ width: "auto", marginLeft: 1 }}
								variant="contained"
								onClick={() => {
									sendAppToBuild();
								}}
								size="medium"
								disabled={loading}
							>
								{loading ? (
									<CircularProgress size={12} />
								) : (
									t("publish.confirm")
								)}
							</Button>
						</Box>
					</Box>
				</Modal>
			</div>

			<div>
				<Modal
					open={showPublishModal}
					onClose={() => {
						setShowPublishModal(false);
					}}
				>
					<Box
						sx={{
							position: "absolute",
							top: "50%",
							left: "50%",
							transform: "translate(-50%, -50%)",
							width: 800,
							bgcolor: "background.paper",
							boxShadow: 24,
							p: 4,
							maxHeight: "calc(100% - 80px)",
							overflow: "auto",
						}}
					>
						<Typography id="modal-modal-title" variant="h6" component="h2">
							{t("publish.sendPublishModalTitle")}
						</Typography>
						<Divider
							sx={{
								marginLeft: -30,
								maxWidth: "calc(100% + 60px)",
								width: "calc(100% + 60px)",
								marginTop: 2,
							}}
						/>
						<Typography
							id="modal-modal-title"
							variant="body1"
							component="p"
							sx={{ marginTop: 4 }}
						>
							{t("publish.sendPublishModalDesc1")}
							<br />
							<br />
							{t("publish.sendPublishModalDesc2")}
							<br />
							<br />
							{t("publish.sendPublishModalDesc3")}{" "}
							<b>{t("publish.sendPublishModalDesc4")}</b>
						</Typography>
						<Box
							sx={{
								display: "flex",
								justifyContent: "flex-end",
								alignItems: "center",
								marginTop: 4,
							}}
						>
							<Button
								variant="outlined"
								onClick={() => {
									setShowPublishModal(false);
								}}
								size="medium"
								disabled={loading}
							>
								{loading ? <CircularProgress size={12} /> : t("publish.cancel")}
							</Button>
							<Button
								sx={{ width: "auto", marginLeft: 1 }}
								variant="contained"
								onClick={() => {
									sendAppToPublish();
								}}
								size="medium"
								disabled={loading}
							>
								{loading ? (
									<CircularProgress size={12} />
								) : (
									t("publish.confirm")
								)}
							</Button>
						</Box>
					</Box>
				</Modal>
			</div>

			<div>
				<Modal
					open={showMetadataModal}
					onClose={() => {
						setShowMetadataModal(false);
					}}
				>
					<Box
						sx={{
							position: "absolute",
							top: "50%",
							left: "50%",
							transform: "translate(-50%, -50%)",
							width: 800,
							bgcolor: "background.paper",
							boxShadow: 24,
							p: 4,
							maxHeight: "calc(100% - 80px)",
							overflow: "auto",
						}}
					>
						<Typography id="modal-modal-title" variant="h6" component="h2">
							{t("publish.metadataModalTitle")}
						</Typography>
						<Divider
							sx={{
								marginLeft: -30,
								maxWidth: "calc(100% + 60px)",
								width: "calc(100% + 60px)",
								marginTop: 2,
							}}
						/>
						<Typography
							id="modal-modal-title"
							variant="body1"
							component="p"
							sx={{ marginTop: 4 }}
						>
							{t("publish.metadataModalDesc")}
						</Typography>
						<Box
							sx={{
								display: "flex",
								justifyContent: "flex-end",
								alignItems: "center",
								marginTop: 4,
							}}
						>
							<Button
								variant="outlined"
								onClick={() => {
									setShowMetadataModal(false);
								}}
								size="medium"
								disabled={loading}
							>
								{loading ? <CircularProgress size={12} /> : t("publish.cancel")}
							</Button>
							<Button
								sx={{ width: "auto", marginLeft: 1 }}
								variant="contained"
								onClick={() => {
									navigate("/metadata");
								}}
								size="medium"
								disabled={loading}
							>
								{loading ? (
									<CircularProgress size={12} />
								) : (
									t("publish.goToMetadata")
								)}
							</Button>
						</Box>
					</Box>
				</Modal>
			</div>

			<div>
				<Modal
					open={showBackModal}
					onClose={() => {
						setShowBackModal(false);
					}}
				>
					<Box
						sx={{
							position: "absolute",
							top: "50%",
							left: "50%",
							transform: "translate(-50%, -50%)",
							width: 800,
							bgcolor: "background.paper",
							boxShadow: 24,
							p: 4,
							maxHeight: "calc(100% - 80px)",
							overflow: "auto",
						}}
					>
						<Typography id="modal-modal-title" variant="h6" component="h2">
							{t("publish.sendItBack")}
						</Typography>
						<Divider
							sx={{
								marginLeft: -30,
								maxWidth: "calc(100% + 60px)",
								width: "calc(100% + 60px)",
								marginTop: 2,
							}}
						/>
						{user.app.appStatuses.filter((status) => status.status === "built")
							.length < 5 ? (
							<>
								<Typography
									id="modal-modal-title"
									variant="body1"
									component="p"
									sx={{ marginTop: 4 }}
								>
									{t("publish.sendItBackDesc1")}
									<br />
									<br />
									{t("publish.sendItBackDesc2")}
									<br />
									<br />
									<b style={{ fontSize: 16 }}>{t("publish.sendItBackDesc3")}</b>
								</Typography>
								<Box
									sx={{
										display: "flex",
										justifyContent: "flex-end",
										alignItems: "center",
										marginTop: 4,
									}}
								>
									<Button
										variant="outlined"
										onClick={() => {
											setShowBackModal(false);
										}}
										size="medium"
										disabled={loading}
									>
										{t("publish.cancel")}
									</Button>
									<Button
										sx={{ width: "auto", marginLeft: 1 }}
										variant="contained"
										onClick={() => {
											sendAppBack();
										}}
										size="medium"
										disabled={loading}
									>
										{loading ? (
											<CircularProgress size={12} sx={{ color: "#fff" }} />
										) : (
											t("publish.confirm")
										)}
									</Button>
								</Box>
							</>
						) : (
							<>
								<Typography
									id="modal-modal-title"
									variant="body1"
									component="p"
									sx={{ marginTop: 4 }}
								>
									{t("publish.sendItBackDesc4")}
									<br />
									<br />
									{t("publish.sendItBackDesc5")}
								</Typography>
								<Box
									sx={{
										display: "flex",
										justifyContent: "flex-end",
										alignItems: "center",
										marginTop: 4,
									}}
								>
									<Button
										variant="contained"
										onClick={() => {
											setShowBackModal(false);
										}}
										size="medium"
										disabled={loading}
									>
										OK
									</Button>
								</Box>
							</>
						)}
					</Box>
				</Modal>
			</div>

			<div>
				<Modal
					open={showPublishBackModal}
					onClose={() => {
						setShowPublishBackModal(false);
					}}
				>
					<Box
						sx={{
							position: "absolute",
							top: "50%",
							left: "50%",
							transform: "translate(-50%, -50%)",
							width: 800,
							bgcolor: "background.paper",
							boxShadow: 24,
							p: 4,
							maxHeight: "calc(100% - 80px)",
							overflow: "auto",
						}}
					>
						<Typography id="modal-modal-title" variant="h6" component="h2">
							{t("publish.sendItBack")}
						</Typography>
						<Divider
							sx={{
								marginLeft: -30,
								maxWidth: "calc(100% + 60px)",
								width: "calc(100% + 60px)",
								marginTop: 2,
							}}
						/>

						<Typography
							id="modal-modal-title"
							variant="body1"
							component="p"
							sx={{ marginTop: 4 }}
						>
							{t("publish.sendItBackDesc1")}
							<br />
							<br />
							{t("publish.sendItBackDesc2")}
						</Typography>
						<Box
							sx={{
								display: "flex",
								justifyContent: "flex-end",
								alignItems: "center",
								marginTop: 4,
							}}
						>
							<Button
								variant="outlined"
								onClick={() => {
									setShowPublishBackModal(false);
								}}
								size="medium"
								disabled={loading}
							>
								{t("publish.cancel")}
							</Button>
							<Button
								sx={{ width: "auto", marginLeft: 1 }}
								variant="contained"
								onClick={() => {
									sendAppBackPublish();
								}}
								size="medium"
								disabled={loading}
							>
								{loading ? (
									<CircularProgress size={12} sx={{ color: "#fff" }} />
								) : (
									t("publish.confirm")
								)}
							</Button>
						</Box>
					</Box>
				</Modal>
			</div>
		</>
	);
}
